<div class="color-palette-assignment">
  <div class="color-palette-dropdown-menu">
    <span class="title">Color</span>

    <mode-color-palette-selector
      [selectedColorPalette]="selectedColorPalette"
      [allColorPalettes]="allColorPalettes"
      buttonHeight="compact"
      (paletteChanged)="onPaletteChanged($event)">
    </mode-color-palette-selector>
  </div>

  <mode-color-palette-preview-swatch
    class="color-swatch"
    [selectedColorPalette]="selectedColorPalette"
    [limit]="10"
    size="full-width"
  ></mode-color-palette-preview-swatch>

  <capra-button
    class="assign-button"
    data-test="color-palette-assign"
    size="small"
    text="Assign Palette"
    variant="secondary"
    color="neutral"
    (clicked)="onAssignPaletteClick()">
  </capra-button>
</div>